var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHatchbak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_393",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29225",
    "data-name": "Group 29225",
    transform: "translate(360 10575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -360, -10575)",
    filter: "url(#Ellipse_393)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_393-2",
    "data-name": "Ellipse 393",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_13_",
    "data-name": "svgexport-17 (13)",
    transform: "translate(-340.316 -10556.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50503",
    "data-name": "Path 50503",
    d: "M492.32,282.216l-1.074-.568v1.089Zm0,0",
    transform: "translate(-458.976 -263.147)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50504",
    "data-name": "Path 50504",
    d: "M15.282,210l-3.47-2.441a6.048,6.048,0,0,0-2.324-2.966c-1.561-.9-2.827.056-2.827,2.138a6.772,6.772,0,0,0,2.827,5.4,1.778,1.778,0,0,0,1.918.107Zm13.149,7.686-3.47-2.441a6.046,6.046,0,0,0-2.324-2.966c-1.562-.9-2.827.055-2.827,2.137a6.771,6.771,0,0,0,2.827,5.4,1.778,1.778,0,0,0,1.918.107Zm0,0",
    transform: "translate(-6.223 -190.833)",
    fill: "#23292e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50505",
    "data-name": "Path 50505",
    d: "M32.839,19.081l-.1.055A8,8,0,0,0,30.5,14.962l-2.689-2.648-.561-1.045a16,16,0,0,0-6.113-6.3L12.5,0,1.5,6.377,1.3,8.472A11.639,11.639,0,0,0,0,13.825V14.2a3.8,3.8,0,0,0,1.9,3.29l18.02,10.424.046.029.083.046.093.054q.05.029.1.052l.025.011q.044.019.089.034l.012,0a3.85,3.85,0,0,0,3.445-.2l8.269-4.78a3.105,3.105,0,0,0,1.551-2.688V19.54A.529.529,0,0,0,32.839,19.081Zm0,0",
    transform: "translate(0)",
    fill: "#63dbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50506",
    "data-name": "Path 50506",
    d: "M32.839,109.782,23.124,115.4a2.768,2.768,0,0,1-1.482.369A8,8,0,0,0,19.5,112.04l-2.688-2.648-.561-1.045a16,16,0,0,0-6.113-6.3L1.5,97.078l-.2,2.095A11.642,11.642,0,0,0,0,104.526v.38a3.8,3.8,0,0,0,1.9,3.29l18.02,10.424.046.029.084.046.093.054a1.191,1.191,0,0,0,.228.1,3.849,3.849,0,0,0,3.445-.2l8.269-4.78a3.105,3.105,0,0,0,1.551-2.688v-.937A.529.529,0,0,0,32.839,109.782Zm0,0",
    transform: "translate(0 -90.701)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50507",
    "data-name": "Path 50507",
    d: "M212.483,326.995c0,2.082-1.266,3.039-2.827,2.138a6.771,6.771,0,0,1-2.827-5.4c0-2.082,1.266-3.039,2.827-2.137A6.771,6.771,0,0,1,212.483,326.995Zm0,0",
    transform: "translate(-193.242 -300.15)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50508",
    "data-name": "Path 50508",
    d: "M231.487,355.874c0,1.024-.622,1.494-1.39,1.051a3.33,3.33,0,0,1-1.39-2.656c0-1.024.623-1.494,1.39-1.051A3.329,3.329,0,0,1,231.487,355.874Zm0,0",
    transform: "translate(-213.683 -329.859)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50509",
    "data-name": "Path 50509",
    d: "M239.9,368.657c0,.555-.337.81-.754.57a1.805,1.805,0,0,1-.754-1.441c0-.555.337-.81.754-.57A1.805,1.805,0,0,1,239.9,368.657Zm0,0",
    transform: "translate(-222.735 -343.01)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50510",
    "data-name": "Path 50510",
    d: "M12.315,209.992c0,2.082-1.266,3.039-2.827,2.138a6.772,6.772,0,0,1-2.827-5.4c0-2.082,1.266-3.039,2.827-2.137A6.771,6.771,0,0,1,12.315,209.992Zm0,0",
    transform: "translate(-6.223 -190.833)",
    fill: "#2e373d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50511",
    "data-name": "Path 50511",
    d: "M31.323,238.872c0,1.024-.622,1.494-1.39,1.051a3.329,3.329,0,0,1-1.39-2.656c0-1.024.622-1.494,1.39-1.051A3.329,3.329,0,0,1,31.323,238.872Zm0,0",
    transform: "translate(-26.668 -220.543)",
    fill: "#cecece"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50512",
    "data-name": "Path 50512",
    d: "M39.735,251.654c0,.555-.337.81-.754.57a1.805,1.805,0,0,1-.754-1.441c0-.555.337-.811.754-.57A1.806,1.806,0,0,1,39.735,251.654Zm0,0",
    transform: "translate(-35.716 -233.692)",
    fill: "#627681"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50513",
    "data-name": "Path 50513",
    d: "M235.373,138.849l9.887-5.73-2.212-3.3a1.933,1.933,0,0,0-2.581-.592l-6.147,3.591a2.055,2.055,0,0,0-.759,2.775Zm0,0",
    transform: "translate(-217.975 -120.494)",
    fill: "#304e75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50514",
    "data-name": "Path 50514",
    d: "M462.658,267.938l-1.637.954a.776.776,0,0,0-.385.67v1.354l2.485-1.435A8.032,8.032,0,0,0,462.658,267.938Zm0,0",
    transform: "translate(-430.377 -250.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50515",
    "data-name": "Path 50515",
    d: "M484.578,269.758l.481-.278a7.991,7.991,0,0,0-.463-1.543l-.479.279A8.458,8.458,0,0,1,484.578,269.758Zm0,0",
    transform: "translate(-452.316 -250.336)",
    fill: "#ef9910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50516",
    "data-name": "Path 50516",
    d: "M302.53,347.849l1.814-1.047v-.9a.525.525,0,0,0-.787-.454l-1.559.9a1.03,1.03,0,0,1-1.028,0l-1.055-.609a2.206,2.206,0,0,0,1.1,1.911l.354.2A1.159,1.159,0,0,0,302.53,347.849Zm0,0",
    transform: "translate(-280.213 -322.686)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50517",
    "data-name": "Path 50517",
    d: "M301.408,351.62a1.022,1.022,0,0,1-.439-.128l-1.055-.609a2.206,2.206,0,0,0,1.1,1.911l.354.2a1.154,1.154,0,0,0,.539.152A7.99,7.99,0,0,0,301.408,351.62Zm0,0",
    transform: "translate(-280.213 -327.834)",
    fill: "#ef9910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50518",
    "data-name": "Path 50518",
    d: "M264.844,197.91l5.947,4.4,7.3-4.2-3.359-5.931Zm0,0",
    transform: "translate(-247.447 -179.556)",
    fill: "#2eb3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50519",
    "data-name": "Path 50519",
    d: "M132.133,183.665l7.219,4.075-2.089-2.972A7.445,7.445,0,0,0,134.9,182.6l-2.763-1.6Zm0,0",
    transform: "translate(-123.453 -169.118)",
    fill: "#243b58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50520",
    "data-name": "Path 50520",
    d: "M327.8,132.994l-2.09-2.972a7.441,7.441,0,0,0-.877-1.03,1.925,1.925,0,0,0-1,.262l-1.3.762Zm0,0",
    transform: "translate(-301.337 -120.519)",
    fill: "#59718b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50521",
    "data-name": "Path 50521",
    d: "M38.073,144.216,35,142.444a1.608,1.608,0,0,0-2.286.769l-.221.524,5.577,3.148Zm0,0",
    transform: "translate(-30.361 -132.885)",
    fill: "#243b58"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatchbak);
export default __webpack_public_path__ + "static/media/hatchbak.e9fef623f9dd9fe29c871853d0d75b33.svg";
export { ForwardRef as ReactComponent };